import { render, staticRenderFns } from "./ClozeSection.vue?vue&type=template&id=0ca11619&scoped=true&"
import script from "./ClozeSection.vue?vue&type=script&lang=js&"
export * from "./ClozeSection.vue?vue&type=script&lang=js&"
import style0 from "./ClozeSection.vue?vue&type=style&index=0&id=0ca11619&lang=scss&scoped=true&"
import style1 from "./ClozeSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca11619",
  null
  
)

export default component.exports